// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-img img[data-v-cc2c1456],.user-letter img[data-v-cc2c1456]{border-radius:50%;-o-object-fit:cover;object-fit:cover;width:40px;height:40px}.popout-window i[data-v-cc2c1456]{color:#50c878}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
